module.exports = __webpack_public_path__ + "img/has-coupon-icon@2x.1ca801a5.png";